/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Type_LiveInputs */

const en_new_project_type_live = /** @type {(inputs: New_Project_Type_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live`)
};

const fr_new_project_type_live = /** @type {(inputs: New_Project_Type_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En direct`)
};

const de_new_project_type_live = /** @type {(inputs: New_Project_Type_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live`)
};

const it_new_project_type_live = /** @type {(inputs: New_Project_Type_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vivere`)
};

const ru_new_project_type_live = /** @type {(inputs: New_Project_Type_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Жить`)
};

const es_new_project_type_live = /** @type {(inputs: New_Project_Type_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vivir`)
};

const zh_cn2_new_project_type_live = /** @type {(inputs: New_Project_Type_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`居住`)
};

const ja_new_project_type_live = /** @type {(inputs: New_Project_Type_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ライブ`)
};

const hi_new_project_type_live = /** @type {(inputs: New_Project_Type_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रहना`)
};

const pt_pt2_new_project_type_live = /** @type {(inputs: New_Project_Type_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ao vivo`)
};

/**
* | output |
* | --- |
* | "Live" |
*
* @param {New_Project_Type_LiveInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_type_live = /** @type {((inputs?: New_Project_Type_LiveInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Type_LiveInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_type_live(inputs)
	if (locale === "de") return de_new_project_type_live(inputs)
	if (locale === "it") return it_new_project_type_live(inputs)
	if (locale === "ru") return ru_new_project_type_live(inputs)
	if (locale === "es") return es_new_project_type_live(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_type_live(inputs)
	if (locale === "ja") return ja_new_project_type_live(inputs)
	if (locale === "hi") return hi_new_project_type_live(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_type_live(inputs)
	return en_new_project_type_live(inputs)
});